//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var script = {
  name: 'PtAlert',
  props: {
    variant: {
      type: String,
      default: 'info',
      description: 'Define the type of Alert. Supports `success`, `error`, `info`, `warning` types',
    },
    dismissible: {
      type: Boolean,
      default: false,
      description: 'Show/hide the cross button of alert.',
    },
    autoClose: {
      type: Boolean,
      default: false,
      description: 'Alert will autoclose after the certain time.',
    },
    autoCloseIn: {
      type: Number,
      default: 5000,
      description: 'Alert will close after the defined milliseconds',
    },

  },
  data: function data() {
    return {
      show: true,
      variantType: '',
      colorByVariant: {
        info: 'grey-darker',
        success: 'green',
        error: 'red',
        warning: 'yellow-dark',
      },
    };
  },
  computed: {
    getVariantClass: function getVariantClass() {
      return ("bg-" + (this.variantType));
    },
  },
  created: function created() {
    if (this.autoClose) {
      setTimeout(this.dismiss, this.autoCloseIn);
    }
    this.variantType = (this.variant in this.colorByVariant) ? this.colorByVariant[this.variant] : this.colorByVariant.info;
  },
  methods: {
    dismiss: function dismiss() {
      this.show = false;
      this.$emit('alertclose');
    },
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.show
    ? _c(
        "div",
        {
          staticClass:
            "flex items-center text-white text-sm font-bold p-5 m-5 rounded relative",
          class: _vm.getVariantClass,
          attrs: { role: "alert" }
        },
        [
          _c("p", [_vm._t("default")], 2),
          _vm._v(" "),
          _vm.dismissible
            ? _c(
                "span",
                {
                  staticClass:
                    "absolute pin-t pin-b pin-r px-4 py-4 cursor-pointer",
                  on: { click: _vm.dismiss }
                },
                [_c("i", { staticClass: "fa fa-times" })]
              )
            : _vm._e()
        ]
      )
    : _vm._e()
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Alert = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

export { Alert as PtAlert };
